export default {

    //As an app developer you do have access these settings while your app is in standalone mode.
    //Control of these features will be limited in App Catalog Mode.

    //Allows you to remove the main navigation from your app.
    //You will have to implement your own navigation.
    //Please, work with the team for suggestions on how to do this.
    mainNavEnabled : true,

    //Allows you to remove the top bar from your app.
    topBarEnabled : true,

    //Allow users to configure UI Colors in the Settings Page
    userSpecifyColorsEnabled : true,

    //Allows the users to configure their own background in the Settings Page.
    userSpecifyBackgroundEnabled : true,

    //Allows the users to configure their own themes in the Settings Page.
    userSpecifyThemesEnabled : true,

    //Determines whether the app is in darkmode by default.
    darkModeDefault : false,

    themes : [
        {
            id : "theme-dark",
            name : "LYB - Dark UI",
            dark : true,
            navBackgroundColor: {"a":0.001,"r":0,"g":0,"b":0},
            contentBackgroundColor: {"a":0.001,"r":0,"g":0,"b":0},
            appBackgroundColor: {"a":0.8403614457831325,"r":0,"g":0,"b":0},
            topBarColor : {"r":13,"g":71,"b":161,"a":1},
            backgroundImage:'Night Work'
        },
        {
            id : "theme-light",
            name : "LYB - Light UI",
            dark : false,
            navBackgroundColor: { r: 232, g: 232, b: 232, a: .9 },
            contentBackgroundColor: { r: 255, g: 255, b: 255, a: 1 },
            appBackgroundColor: { r: 255, g: 255, b: 255, a: 0 },
            topBarColor : { r: 13, g: 71, b: 161, a: 1 },
            backgroundImage:'Night Work'
        }
    ],

    defaultTheme : "theme-light",

    defaultRouteRedirect: "/workstudy"
    
}